import importerReducers from 'src/modules/shared/importer/importerReducers';
import actions from 'src/modules/respuesta/importer/respuestaImporterActions';

export default importerReducers(actions);
